import { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import MembershipService from '../../../../services/membership_service';
import { useTenant } from '../../../../hooks/useTenant';

export const useMemberships = () => {
    const { idTenant, user: authUser } = useTenant();

    const [memberships, setMemberships] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    const loadMemberships = useCallback(async () => {
        if (!idTenant) return;
        setLoading(true);
        try {
            const data = await MembershipService.getMemberships(idTenant);
            setMemberships(data);
        } catch (error) {
            toast.error("Erro ao carregar as memberships.");
        } finally {
            setLoading(false);
        }
    }, [idTenant]);

    useEffect(() => {
        loadMemberships();
    }, [loadMemberships]);

    const saveMembership = async (membershipData) => {
        setIsSaving(true);
        try {
            const savedMembership = await MembershipService.save(membershipData, idTenant, authUser, memberships);

            setMemberships(prev => {
                const index = prev.findIndex(m => m.id === savedMembership.id);
                if (index !== -1) {
                    const newMemberships = [...prev];
                    newMemberships[index] = savedMembership;
                    return newMemberships;
                }
                return [...prev, savedMembership];
            });

            toast.success(membershipData.id ? "Membership atualizada!" : "Membership criada!");
            return true;
        } catch (error) {
            toast.error("Erro ao salvar a membership.");
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    const deleteMembership = async (membershipId) => {
        const membership = memberships.find(m => m.id === membershipId);
        setIsSaving(true);
        try {
            await MembershipService.delete(membershipId, idTenant, authUser, membership?.name);
            setMemberships(prev => prev.filter(m => m.id !== membershipId));
            toast.success("Membership excluída!");
            return true;
        } catch (error) {
            toast.error("Erro ao excluir a membership.");
            return false;
        } finally {
            setIsSaving(false);
        }
    };

    const reorderMemberships = async (reorderedItems) => {
        setMemberships(reorderedItems);
        try {
            await MembershipService.reorder(reorderedItems, idTenant, authUser);
        } catch (error) {
            toast.error("Erro ao salvar nova ordem.");
            loadMemberships();
        }
    };

    return {
        memberships,
        loading,
        isSaving,
        actions: {
            saveMembership,
            deleteMembership,
            reorderMemberships
        }
    };
};
